export default __webpack_public_path__ + "static/media/amertrad7.d6a5ebf9.png";